module.exports = __webpack_public_path__ + "static/media/tan-sponged-background.d0831d1f.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/booklet-react-component/dist/tan-sponged-background.png
// module id = 365
// module chunks = 0